<template>
    <div class="countrypicker-container">
        <v-autocomplete
            v-model="selectedCountry"
            v-model:search="search"

            :items="filteredCountries"
            :label="getSearchBoxLabel()"
            hide-details
            item-title="country_name"
            item-value="country_object_code"
            no-data-text="No matching countries"
            class="countrypicker"
            density="comfortable"

            :disabled="!!initialCountry"
            
            :menu-icon="getIcon('menu')"

            :menu-props="{ maxHeight: 150}"
            
            rounded="8"
            variant="solo"
            flat
        >
              <template v-slot:item="{ props, item }">
                <v-list-item
                class="listItem"
                  v-bind="props"
                  :prepend-avatar="getFlagUrl(item)"
                  :title="item.raw.country_name"
                  @click="selectedCountry = item"
                ></v-list-item>
              </template>
              <template v-slot:prepend-inner>
                <v-avatar>     
                    <v-img v-if="this.initialCountry || this.selectedCountry" :src="getIcon('prependInner')" />
                    <v-icon v-else>{{ getIcon('prependInner') }}</v-icon>
                </v-avatar>
              </template>
        </v-autocomplete>
    </div>
</template>

<script>

import store from '@/store/index';
// TODO the boarders are not quite right
export default {
    name: 'CountryPicker',
    props: {
        initialCountry: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            selectedCountry: null,
            countries: [],
            maxResults: 3,
            search: '',
            isMobile: window.innerWidth <= 900
        };
    },
    async mounted() {
        await this.loadCountries();
        this.countries.sort((a, b) => a.country_name.localeCompare(b.country_name));
        if (this.initialCountry) {
            this.selectedCountry = this.getInitialCountry();
        }
    },
    methods: {
        getIcon(val) {
            switch (val) {
                case 'prependInner':
                    return this.selectedCountry ? this.getFlagUrl(this.selectedCountry) : 'mdi-magnify';
                case 'menu':
                    return this.initialCountry ? '' : 'mdi-chevron-down';
                default:
                    return '';
            }            
        },
        getSearchBoxLabel() {
            return this.selectedCountry ? '' : 'Search';
        },
        async loadCountries() {
            const allCountriesModule = await import('@/data/allCountryData.json');
            const allCountries = allCountriesModule.default;

            this.countries = allCountries.map(country => ({
                country_name: country.country_name,
                country_code: country.country_object_code.toLowerCase(),
            }));
        },
        getFlagUrl(country) {            
            try {
                let countryCode;
                if (country.raw) {
                    countryCode = country.raw.country_code;
                } else {
                    countryCode = country.country_code;
                }
                return require(`@/assets/flags/${countryCode.toLowerCase()}.svg`);
            } catch (e) {
                // console.error('Error getting flag url', e);
                return require('@/assets/flags/unknown.svg');
            }
        },
        getInitialCountry() {
            if (!this.countries) {
                return null;
            }
            if (this.initialCountry && this.initialCountry.country_object_code) { 
                const foundCountry = this.countries.find(country => country.country_code === this.initialCountry.country_object_code.toLowerCase());
                return foundCountry;
            }
        }
    },
    computed: {
        filteredCountries() {
            const allCountries = store.getters['countryStoreData/allCountries'];
            let countries = [];

            for (let index = 0; index < this.countries.length; index++) {
                const country = this.countries[index];

               for (let allIndex = 0; allIndex < allCountries.length; allIndex++) {
                const fullCountry = allCountries[allIndex];
                if(fullCountry.country_object_code.toLowerCase() === country.country_code){
                    if(fullCountry.industryPerformance.length > 0){
                        countries.push(country);
                    }
                }
               }
                
            }
            return countries;
            
        }
        
    },
    watch: {
        selectedCountry: {
            immediate: true,
            handler(val) {
                if (val) {
                    
                    if (val.raw) {
                        this.$emit('selectedCountry', val.raw.country_code.toUpperCase());
                    } else {
                        this.$emit('selectedCountry', val.country_code.toUpperCase());
                    }                    
                }
            }
        }
    }
};
</script>

